import React from 'react';
import {PropTypes} from 'prop-types';

const generateDisplayTitle = (type) => {
    return `${type === 'phone' ? 'Mobile' : 'Tablet'} screenshots`;
}

const imageDisplayWidth = (type) => {
    return type === 'phone' ? 'col-4' : 'col-6';
}

export default function ScreenshotPreview({ title, screenshots }) {
    if (!screenshots.length) { return null }
    return (
        <div className="app-info-text-content row">
            <div className="title col-3">
                {generateDisplayTitle(title)}
            </div>
            <div className="content col-9">
                <div className="app-info-screenshots">
                    {
                        screenshots.map((screenshot, index) => {
                            return (<div key={index} className={`app-info-screenshot ${title} ${imageDisplayWidth(title)}`}>
                                <div className={`screenshot-image ${screenshot.imageIsModified ? 'was-edited' : ''}`}>
                                    <img src={screenshot.path || screenshot.imageURL} alt={`${title} screenshot ${index + 1}`} />
                                    {screenshot.imageIsModified && <span className="sr-only">This image is new</span>}
                                </div>
                                <div className="screenshot-description-wrapper">
                                    <small className={`screenshot-description ${screenshot.descriptionIsModified ? 'was-edited' : ''}`}>
                                        <span className="sr-only">{`Description for screenshot ${index + 1}${screenshot.descriptionIsModified ? '. This description was edited' : ''}: `}</span>
                                        {screenshot.description}
                                    </small>
                                </div>
                            </div>);
                        })
                    }
                </div>
            </div>
        </div>
    );
}

ScreenshotPreview.propTypes = {
    title: PropTypes.string.isRequired,
    screenshots: PropTypes.object.isRequired // mobx observable array
}
